import styled from '@emotion/styled';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  backgroundColor?: string;
  color?: string;
  fontSize?: string;
  padding?: string;
};

type StyledRibbonProps = {} & Exclude<Props, 'children'>;

const StyledRibbon = styled.span<StyledRibbonProps>`
  border-radius: 60px;
  background: ${(props) => props.backgroundColor};
  padding: ${(props) => props.padding};
  text-align: center;
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  font-weight: bold;
  white-space: nowrap;
`;

const Ribbon = ({
  children,
  backgroundColor = 'var(--onsale-color)',
  color = '#fff',
  fontSize = '10px',
  padding = '4px 16px',
}: Props) => {
  return (
    <StyledRibbon backgroundColor={backgroundColor} padding={padding} color={color} fontSize={fontSize}>
      {children}
    </StyledRibbon>
  );
};

export default Ribbon;
